import { computed, ref, Ref } from 'vue'
import { Employee } from '../../employees/models/employee'

// TODO: This component state could take an offer or an employeeId and shiftId then fetch the offer
export type EmployeeArchiveDialogState = {
    employee: Employee | null
    visible: boolean
}

const state: Ref<EmployeeArchiveDialogState> = ref({
    employee: null,
    visible: false,
})

export function useEmployeeArchiveDialog() {
    // TODO: Should use additional type to ensure the shift and employee isn't null
    //  If the offer employee id and the employee object id dont match we probably shouldn't show the dialog
    const show = (data: { employee: Employee }) => {
        console.log('show', data)

        state.value = {
            employee: data.employee,
            visible: true,
        }
    }

    const hide = () => {
        console.log('hide')

        state.value = {
            employee: null,
            visible: false,
        }
    }

    const isShown = computed(() => state.value.visible && state.value.employee !== null)

    const employee = computed(() => state.value.employee)

    return {
        show,
        hide,
        isShown,
        employee,
    }
}